module.exports = __webpack_public_path__ + "static/6i-4e1036758ebde5e016b4b2c16294a3e6.woff";